"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.filter.group': 'Filtra per gruppo',
    'knowledge.filter.all_groups': 'Tutti i gruppi',
    'knowledge.filter.assigned_only': 'Mostra solo conoscenza assegnata',
    'knowledge.filter.by_avatar': 'Filtra per Avatar',
    'knowledge.filter.all_avatars': 'Tutti gli Avatar',
};
